import Vue from 'vue'
import './plugins'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import "@/assets/common.scss"
import Storage from 'vue-ls'

let options = {
  name: 'ls', // name variable Vue.[ls] or this.[$ls],
  storage: 'local', // storage name session, local, memory
};

Vue.use(Storage, options);

Vue.use(ElementUI, { locale })


Vue.config.productionTip = false

let vm = new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')

window.$vm = vm